import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../../shared/components/date-updated-section/date-updated-section.view";
import { Unique } from "../../../../../shared/scripts/array-functions";
import { MilestoneDetailsTab } from "../components/milestone-details-tab/milestone-details.tab";
import { SiteLevelMilestoneDetailsTab } from "../components/milestone-site-details-tab/milestone-site-details.tab";
import { MilestoneSummaryTab } from "../components/milestone-summary-tab/milestone-summary.tab";
import { MilestonesBySite, SiteMetricBenchmark, SiteMetricDetail, SiteMetricSummary, SiteMilestone } from "./site-activation.entities";
import { MilestoneDashboardTab } from "../components/milestone-dashboard-tab/milestone-dashboard-tab";
import { SiteActivationLookup } from "./site-activation.lookup";
import { forEach, sortBy, uniqBy } from "lodash";
import { SiteInfo } from "../../shared/sites.entities";
import { IFilter } from "../../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown, ResetDateFilters, ResetDropdownFilters, SelectDropdownOption } from "../../../../../shared/scripts/filtering/filtering.utilities";

export class SiteActivationPage implements IFilter {

    siteMilestones: SiteMilestone[];
    milestonesBySite: MilestonesBySite[];
    //milestoneIdsToShow: number[] = [1, 6, 22, 25, 33, 30, 32, 24, 34, 26, 27, 8, 9, 10, 14, 36, 31, 16, 17, 19, 35];
    milestoneIdsToShow: number[] = [1, 6, 22, 25, 33, 30, 34, 26, 8, 9, 10, 14, 36, 31, 16, 17, 19, 35];
    siteMetricSummary: SiteMetricSummary[];
    siteMetricDetails: SiteMetricDetail[];
    siteMetricBenchmarks: SiteMetricBenchmark[];

    activeTab: string;
    milestoneDetailsTab: MilestoneDetailsTab;
    milestoneSummaryTab: MilestoneSummaryTab;
    siteLevelMilestoneDetailsTab: SiteLevelMilestoneDetailsTab;
    milestoneDashboardTab: MilestoneDashboardTab;
    selectedPlatforms: string[];
    trialDropdown: string[];
    metricSummaryTab: string = "Platform";

    constructor(
        siteInfoJson: any,
        siteMilestonesJson: any,
        lastUpdatedJson: any,
        siteMetricSummaryJson: any,
        siteMetricDetailsJson: any,
        siteMetricBenchmarksJson: any) {

        $(() => {

            new DateUpdatedSection(lastUpdatedJson);

            let siteInfo: SiteInfo[] = SiteInfo.Parse(siteInfoJson);
            let siteDictionary: Map<number, string> = SiteInfo.CreateNameMap(undefined, siteInfo);

            this.trialDropdown = [
                "Test Filter",
                "AUTONOMIC (IVIG)",
                "AUTONOMIC (Ivabradine)",
                "ENERGIZE (Cardiopulmonary Rehab)",
                "ENERGIZE (Structured Pacing)",
                "NEURO (tDCS & BrainHQ)",
                "SLEEP (Modafinil/Solriamfetol)",
                "SLEEP (Melatonin/Light)",
                "VITAL (Paxlovid)",
            ];

            this.initializeSiteMilestones(siteInfo, siteMilestonesJson);
            this.initializeSiteMetrics(siteDictionary, siteMetricSummaryJson, siteMetricDetailsJson, siteMetricBenchmarksJson);
            this.initializeFilters();

            //console.log(siteScorecardJson);

            this.milestoneDetailsTab = new MilestoneDetailsTab(this.siteMilestones);
            this.milestoneSummaryTab = new MilestoneSummaryTab();
            this.siteLevelMilestoneDetailsTab = new SiteLevelMilestoneDetailsTab(this.milestonesBySite, this.milestoneIdsToShow);

            this.milestoneDashboardTab = new MilestoneDashboardTab(this.siteMetricSummary, this.siteMetricDetails, this.siteMetricBenchmarks);
            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');

            this.showTab("#milestones-summary");
            // this.changeView("#milestones-dashboard");

        });
    }

    changeView(selectedOption: any): void {
        let views: string[] = ['#milestones-summary', '#milestones-details', '#site-level-details', '#milestones-dashboard'];
        views.forEach((id: string) => $(id).removeClass("show active"));

        $(selectedOption).tab('show');
        this.showTab(selectedOption);
    }

    initializeSiteMilestones(siteInfo: SiteInfo[], siteMilestonesJson: any): void {

        let bySiteHash: Map<string, MilestonesBySite> = new Map<string, MilestonesBySite>();

        let currentSiteInfo: SiteInfo = undefined;

        this.siteMilestones = plainToClass(SiteMilestone, <SiteMilestone[]>siteMilestonesJson);
        this.siteMilestones = this.siteMilestones.filter((milestone: SiteMilestone) => milestone.Appendix == "All");

        this.siteMilestones.forEach((milestone: SiteMilestone) => {

            currentSiteInfo = siteInfo.find((x: SiteInfo) => x.SiteNumber == milestone.SiteNumber && x.StudyId == milestone.PrimeContractId);

            if (currentSiteInfo != undefined) {
                milestone.SiteName = currentSiteInfo.SiteName;
            }
            else { milestone.Milestone = "Unknown"; }
            milestone.initialize();

            if (this.milestoneIdsToShow.includes(milestone.MilestoneId)) {

                if (!bySiteHash.has(milestone.MilestoneSiteHash)) {
                    //let scorecard: SiteScorecard = siteScorecards.find((s => s.SiteNumber == milestone.SiteNumber && s.StudyId == milestone.PrimeContractId));
                    bySiteHash.set(milestone.MilestoneSiteHash, new MilestonesBySite(milestone.PrimeContractId, milestone.SiteNumber, milestone.SiteNumberDisplay, milestone.SiteName, (currentSiteInfo.PI != undefined) ? currentSiteInfo.PI : "", milestone.PrimeContract, milestone.InPlayDisplay, (milestone.IsRecoverCohort == 1) ? "Yes" : "No", milestone.AppendixA, milestone.AppendixB));
                }
                bySiteHash.get(milestone.MilestoneSiteHash).MilestoneCompletionDates[milestone.MilestoneId] = (milestone.DateCompletion.length > 0) ? milestone.DateCompletion : "";

                //temp until By Site moved into separate reporting
                //only add randomization to bySite when an activated site
                if (milestone.MilestoneId == 17 && milestone.DateCompletion.length > 0) {
                    //let scorecard: SiteScorecard = siteScorecards.find((s => s.SiteNumber == milestone.SiteNumber && s.StudyId == milestone.PrimeContractId));
                    if (currentSiteInfo != undefined) {
                        bySiteHash.get(milestone.MilestoneSiteHash).RandomizedCount = currentSiteInfo.Randomized;
                    }
                }
            }

            return milestone;
        });

        this.milestonesBySite = Array.from(bySiteHash.values());
    }

    initializeSiteMetrics(siteDictionary: Map<number, string>, siteMetricSummaryJson: any, siteMetricDetailsJson: any, siteMetricBenchmarksJson: any):void {

        this.siteMetricSummary = plainToClass(SiteMetricSummary, <SiteMetricSummary[]>siteMetricSummaryJson);
        this.siteMetricSummary.forEach((summary) => summary.initialize());

        this.siteMetricDetails = plainToClass(SiteMetricDetail, <SiteMetricDetail[]>siteMetricDetailsJson);
        this.siteMetricDetails.forEach((detail) => {
            detail.initialize();
            detail.SiteName = siteDictionary.get(detail.SiteId);
        });

        this.siteMetricBenchmarks = plainToClass(SiteMetricBenchmark, <SiteMetricBenchmark[]>siteMetricBenchmarksJson);
        this.siteMetricBenchmarks.forEach((benchmark) => benchmark.initialize());

    }

    initializeFilters(): void {
        //InitializeDateSelector('changed-since-date', this);
        //InitializeDateSelector('added-since-date', this);
        InitializeDateSelector('completed-since-date', this);

        InitializeFilterDropdown('#prime-contract-dropdown', Unique(this.siteMilestones.map((milestone: SiteMilestone) => milestone.PrimeContract), true), this);
        this.selectedPlatforms = GetSelectedDropdownValues('#prime-contract-dropdown');
        InitializeFilterDropdown('#trial-dropdown', this.trialDropdown, this);
        InitializeFilterDropdown('#milestone-dropdown', Unique(this.siteMilestones.map((milestone: SiteMilestone) => milestone.Milestone), true), this);
        InitializeFilterDropdown('#site-name-dropdown', Unique(this.siteMilestones.map((milestone: SiteMilestone) => milestone.SiteName), true), this);
        InitializeFilterDropdown('#site-inplay-dropdown', Unique(this.siteMilestones.map((milestone: SiteMilestone) => milestone.InPlayDisplay), true), this);
        SelectDropdownOption('#site-inplay-dropdown', [ "Yes" ]);
        //InitializeFilterDropdown('#vanguard-site-dropdown', Unique(this.siteMilestones.map((milestone: SiteMilestone) => milestone.VanguardSiteDisplay), true, ["Not Applicable"]), this);

        const metrics = sortBy(uniqBy(this.siteMetricSummary, 'MetricId'), 'OrderBy').map((summary) => {
            return {
                id: summary.MetricId,
                name:SiteActivationLookup.GetMetric(summary.MetricId)
            }
        });

        this.initializeMetricFilterDropdown('#metric-dropdown', metrics, this);


    }

    showTab(tabId: string): void {

        //prime-contract always shown

        if (tabId == "#milestones-summary") {
            this.toggleDateAsterick(true);

            ['#site-name-filter', '#milestone-filter', '#metric-filter', '#trial-filter'].forEach((id: string) => $(id).hide());
            ['#completed-since-filter', '#vanguard-site-filter', '#inplay-filter'].forEach((id: string) => $(id).show());
            document.getElementById('navigation-tabs').classList.add('invisible');
        }
        else if (tabId == "#milestones-details") {
            this.toggleDateAsterick(false);

            ['#metric-filter', '#trial-filter'].forEach((id: string) => $(id).hide());
            ['#site-name-filter', '#milestone-filter', '#completed-since-filter', '#vanguard-site-filter', '#inplay-filter'].forEach((id: string) => $(id).show());
            document.getElementById('navigation-tabs').classList.add('invisible');
        }
        else if (tabId == "#site-level-details") {
            this.toggleDateAsterick(false);

            ['#site-name-filter', '#milestone-filter', '#completed-since-filter', '#metric-filter', '#trial-filter'].forEach((id: string) => $(id).hide());
            ['#vanguard-site-filter', '#inplay-filter'].forEach((id: string) => $(id).show());
            document.getElementById('navigation-tabs').classList.add('invisible');
        }
        else if (tabId == "#milestones-dashboard") {
            this.toggleDateAsterick(false);

            ['#site-name-filter', '#milestone-filter', '#completed-since-filter', '#vanguard-site-filter'].forEach((id: string) => $(id).hide());
            ['#metric-filter', '#inplay-filter', '#trial-filter'].forEach((id: string) => $(id).show());
            document.getElementById('navigation-tabs').classList.remove('invisible');
        }

        this.activeTab = tabId;
        this.triggerFilter();
        this.toggleTrial('Platform');
    }

    triggerFilter(): void {
        //console.log("filter triggered");
        const trialDropdownSelected = GetSelectedDropdownValues('#trial-dropdown');
        const trialDropdownSelectionPool = this.trialDropdown.filter((trial) => GetSelectedDropdownValues('#prime-contract-dropdown').includes(trial.split(" ")[0]));
        const filteredTrials = trialDropdownSelected.filter((trial) => GetSelectedDropdownValues('#prime-contract-dropdown').includes(trial.split(" ")[0]));
        let combinedTrials = [
            "AUTONOMIC (Combined)",
            "ENERGIZE (Combined)",
            "NEURO (Combined)",
            "SLEEP (Combined)",
            "VITAL (Combined)",
        ];

        this.trialDropdown.forEach((trial) => {
            if (!GetSelectedDropdownValues('#prime-contract-dropdown').includes(trial.split(" ")[0])) {
                $('#trial-dropdown').find('[value="' + trial + '"]').hide();
            }
            else {
                $('#trial-dropdown').find('[value="' + trial + '"]').show();
            }
            $('#trial-dropdown').selectpicker('refresh');
        });

        const element = document.querySelector('[data-id="trial-dropdown"] .filter-option-inner-inner') as HTMLElement;
        let selectedTrialCount = 0;



        trialDropdownSelected.forEach((trial) => {
            if (trialDropdownSelectionPool.includes(trial)) selectedTrialCount++;
        });

        if (selectedTrialCount == trialDropdownSelectionPool.length) {
            element.textContent = 'All';
            element.style.color = '#212529';
        }
        else {
            if (selectedTrialCount > 0) {
                element.textContent = selectedTrialCount + ' Selected';
                element.style.color = '#212529';
            }
            else {
                element.textContent = 'None Selected';
                element.style.color = '#999';
            }
        }

        if (this.activeTab == "#milestones-details") {
            this.milestoneDetailsTab.updateContent(this.filterSiteMilestones(this.activeTab));
        }
        else if (this.activeTab == "#milestones-summary") {
            this.milestoneSummaryTab.updateContent(this.filterSiteMilestones(this.activeTab + "-all"), this.filterSiteMilestones(this.activeTab + "-nodates"), GetSelectedDropdownValues('#prime-contract-dropdown'));
        }
        else if (this.activeTab == "#site-level-details") {
            this.siteLevelMilestoneDetailsTab.updateContent(this.filterSiteLevelMilestoneDetails());
        }
        else if (this.activeTab == "#milestones-dashboard") {
            if (this.metricSummaryTab == "Platform") { this.milestoneDashboardTab.updateContent(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#metric-dropdown'), GetSelectedDropdownValues('#site-inplay-dropdown'), combinedTrials); }
            else { this.milestoneDashboardTab.updateContent(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#metric-dropdown'), GetSelectedDropdownValues('#site-inplay-dropdown'), filteredTrials); }
        }
    }

    filterSiteMilestones(view: string): SiteMilestone[] {
        let matchingList: SiteMilestone[] = [];
        let matches: boolean;
        this.siteMilestones.forEach((milestone: SiteMilestone) => {
            matches = true; //must match all filters

            if (view == "#milestones-summary-all") {
                if (!milestone.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), undefined, undefined, GetSelectedDate("#completed-since-date"), GetSelectedDropdownValues('#site-inplay-dropdown'))) {
                    matches = false;
                }
            }
            else if (view == "#milestones-summary-nodates") {
                if (!milestone.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), undefined, undefined, undefined, GetSelectedDropdownValues('#site-inplay-dropdown'))) {
                    matches = false;
                }
            }
            else if (view == "#milestones-details") {
                if (!milestone.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#site-name-dropdown'), GetSelectedDropdownValues('#milestone-dropdown'), GetSelectedDate("#completed-since-date"), GetSelectedDropdownValues('#site-inplay-dropdown'))) {
                    matches = false;
                }
            }

            if (matches) { matchingList.push(milestone); /*this.filteredMilestoneHashes.push(milestone.getHash());*/ }
        });
        return matchingList;
    }

    filterSiteLevelMilestoneDetails(): MilestonesBySite[] {
        let matchingList: MilestonesBySite[] = [];
        let matches: boolean;
        this.milestonesBySite.forEach((site: MilestonesBySite) => {
            matches = true; //must match all filters

            if (!site.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#site-inplay-dropdown'), GetSelectedDropdownValues('#vanguard-site-dropdown'))) {
                matches = false;
            }
            if (matches) { matchingList.push(site); }
        });
        return matchingList;
    }

    // TODO refactor
    initializeMetricFilterDropdown(selectId: string, values: any[], tableFilter: IFilter, compoundValues: any[] = undefined, selected: boolean = true) {
        $(selectId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        values.forEach((element: any) => {
            $(selectId).append(new Option(element.name, element.id, false, selected));
        });

        $(selectId).selectpicker("refresh");

        $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            tableFilter.triggerFilter();
        });
    }

    resetFilters(): void {

        ResetDropdownFilters(['#prime-contract-dropdown', '#milestone-dropdown', '#site-name-dropdown', '#site-inplay-dropdown', '#vanguard-site-dropdown', '#metric-dropdown']);
        SelectDropdownOption('#site-inplay-dropdown', ["Yes"]);

        ResetDateFilters(['#completed-since-date']);

        this.milestoneDetailsTab.clearSearchBar();
    }

    toggleDateAsterick(showAsterick: boolean): void {
        if (showAsterick) { $('.date-filter-asterick').show(); }
        else { $('.date-filter-asterick').hide(); }
    }

    setAchievementChartLegend(selection: string): void {
        this.milestoneSummaryTab.setSelectedChartSeries(selection);
    }

    showInfoModal(): void {
        $('#sites-info-modal').modal('show');
    }


    showDetailTableModal(id: any, type: string): void {
        this.milestoneSummaryTab.showDetailTableModal(id, type);
    }

    showDashboardModal(siteId: number, studyId: number, metricId: number, appendixA: number, appendixB: number) {
        const milestones = this.siteMilestones.filter((site) => ((siteId === site.SiteNumber) && (site.AppendixA === appendixA) && (site.AppendixB === appendixB) && (studyId === ['', '', 'VITAL', 'NEURO', 'SLEEP', 'AUTONOMIC', 'ENERGIZE'].indexOf(site.PrimeContract))));
        milestones.sort((a,b) => (a.OrderBy > b.OrderBy) ? 1 : -1 );
        this.milestoneDashboardTab.showModal(siteId, studyId, metricId, milestones, appendixA, appendixB);
    }

    toggleTrial(tab: string): void {
        this.metricSummaryTab = tab;
        const trialDropdown = document.getElementById("trial-filter") as HTMLElement;
        if (tab == "Platform") {

            $('#trial-dropdown').prop('disabled', true);
            $('#trial-dropdown').selectpicker('refresh');
            const element = document.querySelector('[data-id="trial-dropdown"] .filter-option-inner-inner');
            element.textContent = 'Not Available On Platform View';
            let combinedTrials = [
                "AUTONOMIC (Combined)",
                "ENERGIZE (Combined)",
                "NEURO (Combined)",
                "SLEEP (Combined)",
                "VITAL (Combined)",
            ];
            this.milestoneDashboardTab.updateContent(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#metric-dropdown'), GetSelectedDropdownValues('#site-inplay-dropdown'), combinedTrials);
            trialDropdown.style.display = "none";
        }
        else {
            trialDropdown.style.display = "block";
            $('#trial-dropdown').prop('disabled', false);
            $('#trial-dropdown').selectpicker('refresh');
            this.triggerFilter();
        }
    }
}